/**
 * Mock ELDRICK payload for development/testing.
 * Matches the real POST /api/lab/simulate response schema.
 * Represents a mid-handicap driver fitting with realistic launch monitor data.
 */

import type { EldrickPayload } from '../equipment/types';

export const MOCK_ELDRICK_PAYLOAD: EldrickPayload = {
  meta: {
    fittingId: 'ELDR-2026-DEMO',
    fittingType: 'driver',
    fittingDepth: 'deep_fit',
    generatedAt: new Date().toISOString(),
  },
  player: {
    handedness: 'right',
    height: { feet: 5, inches: 10, totalInches: 70 },
    wristToFloor: 33.5,
    weight: 180,
    handicap: 12,
    goals: 'More distance off the tee, reduce slice',
    experience: 'intermediate',
    feelBalance: 'distance',
    controlConfidence: 'moderate',
    overallSatisfaction: 'somewhat_satisfied',
  },
  swing: {
    clubheadSpeed: 98,
    ballSpeed: 143,
    launchAngle: 11.2,
    spinRate: 2650,
    attackAngle: 1.5,
    clubPath: 1.0,
    faceAngle: 0.5,
    carryDistance: 230,
    landingAngle: 38,
    peakHeight: 95,
    peakHeightContext: 'good',
    missPattern: 'fade',
    smashFactor: 1.459,
    faceToPaths: -0.5,
    handedness: 'right',
    dynamicLoft: { value: 13.8, assumed: true, basis: 'Estimated from launch angle / 0.67 + spin rate / 2000' },
    spinAxis: { value: 2.5, assumed: true, basis: 'Estimated as 3 * |faceToPaths|' },
    impactEfficiency: { value: 0.98, assumed: true, basis: 'Smash factor vs. tour-average for 95-105 mph band' },
  },
  swingProfile: {
    tempo: 'medium',
    transition: 'medium',
    release: 'normal',
    strikePattern: 'center',
    dispersionShape: 'less-slices,more-distance',
  },
  gear: {
    loft: 10.5,
    loftLabel: '10.5°',
    lieAngle: 59,
    lieAngleLabel: 'Standard',
    lieAngleOverride: null,
    length: 45.5,
    lengthLabel: 'Standard',
    flex: 'Stiff',
    shaftWeight: 62,
    shaftMaterial: 'Graphite',
    swingWeight: 'D2',
    launchProfile: 'Mid',
    headCategory: 'Max Distance',
    headTypeOverride: null,
    weightSetting: 'Standard',
    adapterSetting: 'neutral',
    effectiveLoft: '10.5',
    swingFlawFlag: false,
    cor: { value: 0.83, assumed: true, basis: 'COR by Max Distance head category' },
    moi: { value: 5200, assumed: true, basis: 'MOI by Max Distance head category' },
    faceThickness: { value: 2.8, assumed: true, basis: 'Face thickness by Max Distance head category' },
  },
  currentSetup: {
    brand: 'TaylorMade',
    model: 'Stealth 2',
    loft: 10.5,
    length: 45.75,
    lengthStep: 1,
    shaftModel: 'Fujikura Ventus Blue 6',
    shaftFlex: 'Stiff',
    shaftWeight: 63,
    shaftMaterial: 'graphite',
    swingWeight: null,
    ball: 'Pro V1x',
    ballCompression: { value: 100, assumed: true, basis: 'Pro V1x known compression' },
  },
};
